import { Controller } from "@hotwired/stimulus"
import { LineChart } from "@carbon/charts"

const SERIES_COLORS = ["#1F6FEB", "#0FB8A0", "#E8A23D", "#8B5CF6", "#E0564B"]

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    series: Array,
    labels: Array
  }

  #chart = null

  connect() {
    this.#build()
  }

  disconnect() {
    this.#chart?.destroy()
    this.#chart = null
  }

  #build() {
    if (!this.hasCanvasTarget || !this.seriesValue.length) return

    const rows = this.seriesValue.flatMap((s, i) =>
      s.data.map(d => ({ group: s.name, key: d.date, value: d.value }))
    )

    const colorScale = Object.fromEntries(
      this.seriesValue.map((s, i) => [s.name, SERIES_COLORS[i % SERIES_COLORS.length]])
    )

    this.#chart = new LineChart(this.canvasTarget, {
      data: rows,
      options: {
        height: "220px",
        axes: {
          left:   { mapsTo: "value", title: "" },
          bottom: { mapsTo: "key", scaleType: "labels", title: "" }
        },
        color: { scale: colorScale },
        curve: "curveMonotoneX",
        points: { radius: 3 },
        legend: { position: "top", alignment: "right", enabled: true },
        toolbar: { enabled: false },
        grid: { x: { enabled: false } }
      }
    })
  }
}
